import React, { useEffect, useRef, useState } from "react";
import CuInput from "../../all-patient/components/CuInput";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { FaBookmark, FaMinus, FaPlus, FaRegBookmark } from "react-icons/fa";
import CuButton from "../../all-patient/components/CuButton";
import CuSpinner from "../../common_component/component/CuSpinner";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { useSecureUpdateItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";

const CommonTest = ({
  closeModal,
  setIsDropdownOpen,
  setCheckedItems,
  setFormData,
  selectedCategory,
  formData,
  setSearchTerm,
  searchTerm,
  handleSubmit,
  checkedItems,
  isDropdownOpen,
  setSelectedCategory,
  updateConsultationMutation,
}) => {
  const { doctor_personal_details, refetch } = useCurrentRole();
  const [clinic] = useAtom(clinicAtom);
  const searchInputRef = useRef(null);
  const [bookmarkTestId, setBookmarkTestId] = useState("");
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [showDoctorLabTests, setShowDoctorLabTests] = useState(true);
  const [expandedTests, setExpandedTests] = useState([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchInputRef, setIsDropdownOpen]);

  const handleCheckboxChange = (item) => {
    setCheckedItems((prev) => {
      if (prev.some((i) => i.id === item.id)) {
        return prev.filter((i) => i.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
  };

  const handleToggleTest = (testId) => {
    setExpandedTests((prev) =>
      prev.includes(testId)
        ? prev.filter((id) => id !== testId)
        : [...prev, testId]
    );
  };

  const handleInputChange = (testId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [testId]: {
        ...prev[testId],
        [field]: value,
      },
    }));
  };

  const { data: categoryData, isLoading: categoryLoading } = useItemsFilter(
    ApiEndPoint.MEDICINE_TAG_DATA,
    `?action=getLabTestCategories&clinic_id=${clinic?.id}&backend=True&name=${searchTerm}`,
    searchTerm && clinic?.id ? true : false
  );

  // const { data: labtestData, isLoading: labTestLoading } = useItemsFilter(
  //   ApiEndPoint.MEDICINE_TAG_DATA,
  //   `?action=getLabTest&clinic_id=${clinic?.id}&backend=True&test_category=${selectedCategory}`,
  //   clinic?.id && selectedCategory ? true : false
  // );

  const { data: getDoctorLabTesttData, isLoading: getDoctorLabTesttLoading } =
    useItemsFilter(
      ApiEndPoint.USERS,
      `?action=getDoctorLabTest&clinic_id=${clinic?.id}&backend=True`,
      clinic?.id ? true : false
    );

  const updateBookmarkMutation = useSecureUpdateItem(
    "users/doctor_personal_detail/"
  );

  const handleUpdateBookMark = (id, action) => {
    const payload = {
      action: "patchDoctorPersonalDetails",
      id: doctor_personal_details?.id,
      clinic_id: clinic?.id,
      backend: "True",
      lab_action: action,
      linked_lab_test: [id],
    };
    updateBookmarkMutation.mutate(
      { id: null, data: payload },
      {
        onSuccess: (data) => {
          action === "add"
            ? toast.success("Bookmarked Test")
            : toast.success("Removed Bookmark Test");
          refetch();
        },
        onError: () => {
          toast.error("update bookmark error");
        },
      }
    );
  };

  // //("labtest-----", doctor_personal_details.linked_lab_test);

  const handleCategoryClick = (categoryId) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleFocus = () => {
    setIsDropdownOpen(true);
    setShowDoctorLabTests(true);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-4 w-[340px] relative" ref={searchInputRef}>
        <CuInput
          placeholder={`Search`}
          label={`Search Test`}
          value={searchTerm}
          onFocus={handleFocus}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsDropdownOpen(true);
            setShowDoctorLabTests(false);
          }}
          loading={categoryLoading}
        />
        {isDropdownOpen && (
          <div className="absolute top-16 bg-white left-0 w-full border z-10 rounded">
            {showDoctorLabTests && getDoctorLabTesttData
              ? getDoctorLabTesttData.map((item) => (
                  <div key={item.id}>
                    <div
                      className="w-full h-12 flex justify-between items-center px-4 border-t cursor-pointer"
                      onClick={() => handleCategoryClick(item.id)}
                    >
                      <span>{item.name}</span>
                      {expandedCategories.includes(item.id) ? (
                        <FaMinus />
                      ) : (
                        <FaPlus />
                      )}
                    </div>
                    {expandedCategories.includes(item.id) &&
                      item.lab_test?.length > 0 &&
                      item.lab_test.map((test) => (
                        <div
                          className="w-full h-12 flex justify-between items-center px-4 border-t"
                          key={test.id}
                        >
                          <span>{test.name}</span>
                          <input
                            type="checkbox"
                            checked={checkedItems.some((i) => i.id === test.id)}
                            onChange={() => handleCheckboxChange(test)}
                            className="cursor-pointer"
                          />
                        </div>
                      ))}
                  </div>
                ))
              : categoryData?.map((item) => (
                  <div key={item.id}>
                    <div
                      className="w-full h-12 flex justify-between items-center px-4 border-t cursor-pointer"
                      onClick={() => handleCategoryClick(item.id)}
                    >
                      <span>{item.name}</span>
                      {expandedCategories.includes(item.id) ? (
                        <FaMinus />
                      ) : (
                        <FaPlus />
                      )}
                    </div>
                    {expandedCategories.includes(item.id) &&
                      item.lab_test?.length > 0 &&
                      item.lab_test.map((test) => (
                        <div
                          className="w-full h-12 flex justify-between items-center px-4 border-t"
                          key={test.id}
                        >
                          <span>{test.name}</span>
                          <input
                            type="checkbox"
                            checked={checkedItems.some((i) => i.id === test.id)}
                            onChange={() => handleCheckboxChange(test)}
                            className="cursor-pointer"
                          />
                        </div>
                      ))}
                  </div>
                ))}
          </div>
        )}
      </div>
      <div className="w-full min-h-96">
        {checkedItems.map((item) => (
          <div className="my-2 w-full flex gap-6" key={item.id}>
            <div className="w-[180px]">
              <div>
                <div className="w-full h-11 flex justify-between items-center border rounded px-4 mt-6">
                  <span>{formData[item.id]?.test_name || item.name}</span>{" "}
                  <input
                    type="checkbox"
                    checked={checkedItems.some((i) => i.id === item.id)}
                    onChange={() => handleCheckboxChange(item)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="mt-1 flex items-center gap-2">
                  {doctor_personal_details.linked_lab_test?.includes(
                    item.id
                  ) ? (
                    <>
                      {updateBookmarkMutation.isLoading &&
                      bookmarkTestId === item?.id ? (
                        <CuSpinner />
                      ) : (
                        <FaBookmark
                          className="cursor-pointer"
                          onClick={() => (
                            handleUpdateBookMark(item.id, "remove"),
                            setBookmarkTestId(item?.id)
                          )}
                        />
                      )}
                      <span className="text-sm">Remove from bookmark</span>
                    </>
                  ) : (
                    <>
                      {updateBookmarkMutation.isLoading &&
                      bookmarkTestId === item?.id ? (
                        <CuSpinner />
                      ) : (
                        <FaRegBookmark
                          className="cursor-pointer"
                          onClick={() => (
                            handleUpdateBookMark(item.id, "add"),
                            setBookmarkTestId(item?.id)
                          )}
                        />
                      )}

                      <span className="text-sm">Add to bookmark</span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="flex-1">
              <div className="w-full flex gap-4 items-center">
                <div className="flex justify-center gap-4 w-full">
                  <div className="flex-1">
                    <div className="w-full flex justify-between items-center">
                      <label>Value</label>
                      <span></span>
                    </div>
                    <input
                      placeholder={`Enter Value`}
                      type="number"
                      value={formData[item.id]?.value || ""}
                      onChange={(e) =>
                        handleInputChange(item.id, "value", e.target.value)
                      }
                      required={true}
                      className="w-full h-11 pl-2 text-sm rounded border outline-none"
                    />
                  </div>
                  <div className="flex-1">
                    <CuInput
                      label={`Reference`}
                      value={
                        formData[item.id]?.reference ||
                        `${item.lab_test_threshold.min_threshold} - ${item.lab_test_threshold.max_threshold}`
                      }
                      required={true}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="flex justify-center gap-4 w-full">
                  <div className="flex-1">
                    <CuInput
                      label={`Unit`}
                      value={formData[item.id]?.unit || item.ufm.name}
                      disabled={true}
                    />
                  </div>
                  <div className="flex-1">
                    <CuInput
                      label={`Date`}
                      type="date"
                      value={
                        formData[item.id]?.date ||
                        new Date().toISOString().split("T")[0]
                      }
                      onChange={(e) =>
                        handleInputChange(item.id, "date", e.target.value)
                      }
                      required={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center gap-4 w-full mt-2">
                <div className="flex-1">
                  <CuInput
                    label={`Note`}
                    placeholder={`Enter Note`}
                    value={formData[item.id]?.note || ""}
                    onChange={(e) =>
                      handleInputChange(item.id, "note", e.target.value)
                    }
                    required={true}
                  />
                </div>
                <div className="flex-1">
                  <CuInput
                    label={`Description`}
                    value={formData[item.id]?.description || ""}
                    onChange={(e) =>
                      handleInputChange(item.id, "description", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {checkedItems.length > 0 && (
        <div className="w-full mt-4 flex items-center gap-4">
          <button
            type="button"
            className="w-[156px] h-11 rounded border"
            onClick={() => {
              setCheckedItems([]);
              setFormData({});
              closeModal();
            }}
          >
            Cancel
          </button>
          <CuButton
            className="w-[156px] h-11 rounded border bg-[#EBF8EC]"
            type="submit"
            isLoading={updateConsultationMutation.isLoading}
          >
            Submit
          </CuButton>
        </div>
      )}
    </form>
  );
};

export default CommonTest;
